import { useEffect, useState } from 'react';

import { ujpAPI, type UjpEnergyPrice } from '@/services/api/ujp';

/**
 * The regions the fuel-price master knows (the "Daerah" picker on the UJP Info
 * step): every distinct non-null `region` across the price history, sorted.
 * A UJP's region only changes the price when the master has a row for it, so
 * offering exactly these keeps ops from typing a region nothing prices.
 */
export const regionsOf = (rows: UjpEnergyPrice[]): string[] =>
  Array.from(
    new Set(
      rows
        .map((r) => r.region?.trim())
        .filter((r): r is string => !!r)
    )
  ).sort((a, b) => a.localeCompare(b, 'id'));

export interface UseEnergyPriceRegionsResult {
  regions: string[];
  loading: boolean;
  error: string | null;
}

export const useEnergyPriceRegions = (): UseEnergyPriceRegionsResult => {
  const [state, setState] = useState<UseEnergyPriceRegionsResult>({
    regions: [],
    loading: true,
    error: null,
  });

  useEffect(() => {
    let alive = true;
    ujpAPI
      .listEnergyPriceHistory()
      .then((rows) => {
        if (alive) setState({ regions: regionsOf(rows ?? []), loading: false, error: null });
      })
      .catch((e: unknown) => {
        if (alive)
          setState({
            regions: [],
            loading: false,
            error: e instanceof Error ? e.message : 'Daftar daerah gagal dimuat',
          });
      });
    return () => {
      alive = false;
    };
  }, []);

  return state;
};
